import { createStore } from "vuex";
import axios from 'axios'
import alumno from './modules/alumno';
import curso from './modules/curso';
import alquiler from "./modules/alquiler";
import servicioexterno from "./modules/servicioexterno";
import cotizacion from "./modules/cotizacion";
import evento from "./modules/evento";
import gasto from "./modules/gasto";
import ingreso from "./modules/ingreso";
import reporte from "./modules/reporte";
import roles from "./modules/roles";
import paquetes from "./modules/paquetes";
import { tienePermiso } from "@/menu";

export default createStore({
  state: {
    user: null,
  },
  getters: {
    isAuthenticated(state) {
      return !!state.user
    },
    can: (state) => (permiso) => tienePermiso(state.user?.permisos, permiso),
  },
  mutations: {
    SET_USER(state, data) {
      state.user = data;
    },
  },
  actions: {
    async getUser({ commit }) {
      try {
        const { data } = await axios.get("/api/user");
        commit("SET_USER", data);
      } catch (e) {
        commit("SET_USER", null);
        throw new Error(await e.response.data.message);
      }
    },
    async login({ dispatch }, credentials) {
      try {
        await axios.post("/login", credentials);
        await dispatch("getUser");
      } catch (e) {
        throw new Error(await e.response.data.message);
      }
    },
    async logout({ commit }) {
      try {
        await axios.post("/logout");
        commit("SET_USER", null);
      } catch (e) {
        throw new Error(await e.response.data.message);
      }
    },
  },
  modules: {
    alumno,
    curso,
    alquiler,
    servicioexterno,
    cotizacion,
    evento,
    gasto,
    roles,
    paquetes,
    ingreso,
    reporte,
  },
});
